import React from 'react'
import { BaseUrl } from '../../../../../Helper/BaseUrl'
import GardenMaintainanceCardManage from './GardenMaintainanceCardManage'

export default function GardenMaintainanceComp() {
    return (
        <>
            <div className="mb-4 m-1 py-2 px-3 master_border" style={{ borderRadius: "15px" }}>
                {/* <div className="mb-4 m-1 py-2 px-3 master_border"> */}
                <GardenMaintainanceCardManage />
            </div>
        </>
    )
}
